import { createSlice } from "@reduxjs/toolkit";

let isDarkMode = false;
const storedDarkMode = localStorage.getItem("darkMode");

if (storedDarkMode === "true") {
  isDarkMode = true;
} else if (storedDarkMode === "false") {
  isDarkMode = false;
} else {
  isDarkMode =
    window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
}

const initialState = {
  isDarkMode
};

const DarkmodeSlice = createSlice({
  name: "DarkmodeSlice",
  initialState,
  reducers: {
    setDarkMode(state, action) {
      state.isDarkMode = action.payload;
      localStorage.setItem("darkMode", JSON.stringify(action.payload));
    }
  }
});

export default DarkmodeSlice;
export const DarkmodeAction = DarkmodeSlice.actions;
